<div class="px-6 py-8">
    <div class="mb-8 animate-fade-in-down">
      <app-page-header
        title="Payment Processing"
        subtitle="Select a vendor to process payment"
      ></app-page-header>
    </div>

   <div class="relative p-4 bg-white rounded-2xl shadow-sm border border-slate-100 animate-fade-in-up">
      <div class="mb-4 flex w-full flex-col sm:flex-row sm:items-center gap-3">
          <div class="relative w-full sm:w-[520px]">
            <svg
              class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <button
              type="button"
              (click)="openFilters()"
              class="w-full pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg text-left text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all duration-200"
            >
              {{
                activeFilterCount
                  ? activeFilterCount +
                    " active filter" +
                    (activeFilterCount > 1 ? "s" : "")
                  : "Search and filter payments"
              }}
            </button>
          </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-[#E6E6E6]">
              <th
                *ngFor="let col of columns"
                class="px-6 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap select-none"
                [class.text-left]="col !== 'Actions'"
                [class.text-center]="col === 'Actions'"
              >
                {{ col }}
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-slate-100">
            @if (isLoadingPayments) {
              <tr>
                <td colspan="8" class="px-6 py-16 text-center">
                  <div class="flex flex-col items-center gap-3">
                    <div
                      class="size-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
                    ></div>
                    <p class="text-sm font-medium text-slate-500">
                      Loading payments...
                    </p>
                  </div>
                </td>
              </tr>
            }

            @if (!isLoadingPayments ) {
              @for (payment of payments; track $index; let i = $index) {
                <tr
                    class="group hover:bg-teal-50/30 transition-colors duration-150 animate-row-in"
                    [style.animation-delay]="i * 60 + 'ms'"
                >
                    <td class="px-6 py-4 font-medium text-slate-700 whitespace-nowrap">
                      {{ payment.date | date:'MMM dd, yyyy, hh:mm a' }}
                    </td>

                    <td class="px-6 py-4 font-medium text-slate-700 whitespace-nowrap">
                      {{ payment.reference }}
                    </td>

                    <td class="px-6 py-4 font-medium text-slate-700 whitespace-nowrap">
                      {{ payment.payerName }}
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                      {{ payment.mdaName || 'N/A' }}
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <span
                            class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-slate-50 text-slate-600 border border-slate-100"
                        >
                            {{ payment.categoryName || 'N/A' }}
                        </span>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                        {{ (payment.amount | currency:'NGN') || "N/A"}}
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <span
                            class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                            [ngClass]="getStatusPillClass(payment.status)"
                        >
                            {{ payment.status || 'PENDING' }}
                        </span>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap text-center">
                      <app-dropdown-menu>
                        <button
                            type="button"
                            class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 hover:text-slate-700 hover:bg-slate-100 transition-colors duration-150"
                            aria-label="Payment actions"
                            trigger
                        >
                          <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          >
                          <path
                              d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                          </svg>
                        </button>

                        <ng-container content>
                          <button (click)="handleReceiptDownload(payment.vendorId)"
                            type="button"
                            class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                          >
                            <svg class="size-4" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_11_834)">
                                <path d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73479 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V4M7 1C7.15828 0.999745 7.31504 1.0308 7.46127 1.09139C7.60749 1.15197 7.74028 1.24088 7.852 1.353L9.646 3.147C9.75842 3.25875 9.84759 3.39167 9.90835 3.53808C9.96911 3.68449 10.0003 3.84149 10 4M7 1V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24021 3.94732 7.36739 4 7.5 4L10 4M6 9V6M7.5 7.5L6 9L4.5 7.5" stroke="#595A69" stroke-linecap="round" stroke-linejoin="round"/>
                              </g>
                              <defs>
                                <clipPath id="clip0_11_834">
                                  <rect width="12" height="12" fill="white"/>
                                </clipPath>
                              </defs>
                            </svg>
                            Download Payment Receipt
                          </button>
                        </ng-container>
                      </app-dropdown-menu>
                    </td>
                </tr>
              } @empty {
                <tr>
                    <td colspan="7" class="px-6 py-16 text-center">
                        <div class="flex flex-col items-center gap-3">
                            <div
                            class="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center"
                            >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6 text-slate-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            </div>
                            <p class="text-sm font-medium text-slate-500">
                            No payments found
                            </p>
                            <p class="text-xs text-slate-400">
                            Try adjusting your search or status filter
                            </p>
                        </div>
                    </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-slate-50/50">
        <p class="text-xs text-slate-400">
          Showing {{ payments.length }} of {{ totalItems }} payments
        </p>
        <div class="flex items-center gap-1">
          <button
            (click)="goToPreviousPage()"
            [disabled]="!hasPreviousPage"
            class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
          >
            Previous
          </button>
          <button
            class="px-3 py-1.5 text-xs bg-vms-bg-secondary text-vms-text-secondary rounded-md shadow-sm"
          >
            {{ currentPage }}
          </button>
          <button
            (click)="goToNextPage()"
            [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
    </div>
</div>

<app-filter-drawer
  [isOpen]="isFilterDrawerOpen"
  title="Filters"
  subtitle="Search and filter payments."
  submitLabel="Apply Filters"
  resetLabel="Clear all"
  [fields]="paymentFilterFields"
  [initialValue]="paymentFilters"
  (close)="closeFilters()"
  (apply)="applyFilters($event)"
></app-filter-drawer>